import React from 'react'

import Button from 'components/button/Button'

const EditBtn = (props) => {
  const { text = 'แก้ไข', loading, disabled, onClick } = props
  return (
    <Button
      small
      text={text}
      loading={loading}
      disabled={disabled}
      onClick={onClick}
    />
  )
}

export default EditBtn
